import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  listCharterHundredDollarPromotion,
  upsertCharterHundredDollarPromotion,
} from '~/services/CharterHundredDollarPromotionService';

import type {
  ListCharterPromotionPricingInventoryParams,
  UpsertCharterPromotionPricingInventoryBody,
} from '~/types/charterPromotionPricingInventory';

import { charterHundredDollarPromotionQueryKeys } from './charterHundredDollarPromotionQueryKeys';

export function useGetCharterHundredDollarPromotionList(
  params: ListCharterPromotionPricingInventoryParams = {},
  options: { enabled?: boolean } = {},
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: charterHundredDollarPromotionQueryKeys.list(params),
    queryFn: async ({ signal }) => {
      return await listCharterHundredDollarPromotion(params, { signal });
    },
    enabled,
  });
}

export function useUpsertCharterHundredDollarPromotion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpsertCharterPromotionPricingInventoryBody) => {
      return await upsertCharterHundredDollarPromotion(body);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: charterHundredDollarPromotionQueryKeys.all });
    },
  });
}
